import React from 'react';
import { BrowserRouter } from 'react-router-dom';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';

import { UiContextProvider } from 'common/UiContext/UiContext';
import { AuthContextProvider } from 'common/auth';

import Layout from 'Layout';

import './App.scss';

const queryClient = new QueryClient({ defaultOptions: { queries: { refetchOnWindowFocus: false } } });

const App = () => (
  <QueryClientProvider client={queryClient}>
    <BrowserRouter>
      <AuthContextProvider>
        <UiContextProvider>
          <Layout />
        </UiContextProvider>
      </AuthContextProvider>
    </BrowserRouter>
  </QueryClientProvider>
);

export default App;
